function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;


//////////////////
// WEBPACK FOOTER
// ./~/@weareroam/cake-ui-v1-icons/~/@babel/runtime/helpers/interopRequireDefault.js
// module id = 30
// module chunks = 35783957827783 153662236231701 175947910196865